module.exports = __webpack_public_path__ + "static/media/2 2 Ordkjedetest-her-ser-du-4-ovingsoppgaver.4843677d.mp3";